import { ROUTES } from 'src/components/Router/router.config';
import { CurrentStep } from 'src/stores/createScenarioStore';

export type ScenarioState =
  | 'Created'
  | 'DatabricksGenerateFileJobStarted'
  | 'DatabricksGenerateFileJobFailed'
  | 'DatabricksGenerateFileJobSuccessful'
  | 'SanityCheckStarted'
  | 'SanityCheckFailed'
  | 'SanityCheckDatabricksFailed'
  | 'SanityCheckSuccessful'
  | 'RunScenarioPending'
  | 'RunScenarioStarted'
  | 'RunScenarioFailed'
  | 'RunScenarioSuccessful';

export const DRAFT_STATES_SCREEN_MAPPING: Omit<
  Record<ScenarioState, (param: string) => void>,
  | 'DatabricksGenerateFileJobStarted'
  | 'SanityCheckStarted'
  | 'RunScenarioPending'
  | 'RunScenarioStarted'
  | 'RunScenarioFailed'
  | 'RunScenarioSuccessful'
> = {
  Created: ROUTES.TEMPLATE_CONFIGURATION,
  DatabricksGenerateFileJobFailed: ROUTES.TEMPLATE_CONFIGURATION,
  DatabricksGenerateFileJobSuccessful: ROUTES.VALIDATION_MODEL,
  SanityCheckFailed: ROUTES.VALIDATION_MODEL,
  SanityCheckDatabricksFailed: ROUTES.VALIDATION_MODEL,
  SanityCheckSuccessful: ROUTES.VALIDATION_MODEL,
};

export const STATUS_MAPPING: Omit<
  Record<ScenarioState, string>,
  | 'DatabricksGenerateFileJobStarted'
  | 'SanityCheckStarted'
  | 'RunScenarioPending'
  | 'RunScenarioStarted'
  | 'RunScenarioFailed'
  | 'RunScenarioSuccessful'
> = {
  Created: 'Template Configuration Pending',
  DatabricksGenerateFileJobFailed: 'Template Configuration Databricks Error',
  DatabricksGenerateFileJobSuccessful: 'Sanity Check Pending',
  SanityCheckFailed: 'Sanity Check Failed',
  SanityCheckDatabricksFailed: 'Sanity Check Databricks Error',
  SanityCheckSuccessful: 'Sanity Check Successful ',
};

export const getDraftUrlFromState = (scenarioState: ScenarioState): ((param: string) => string) => {
  return DRAFT_STATES_SCREEN_MAPPING[scenarioState] ?? (() => '');
};

const stateMapping = {
  Created: CurrentStep.SCENARIO_CREATED,
  DatabricksGenerateFileJobStarted: CurrentStep.SUBMITTING_TEMPLATE,
  DatabricksGenerateFileJobFailed: CurrentStep.SCENARIO_CREATED,
  DatabricksGenerateFileJobSuccessful: CurrentStep.TEMPLATE_CREATED,
  SanityCheckStarted: CurrentStep.VALIDATION_MODEL_SUBMITTING,
  SanityCheckFailed: CurrentStep.VALIDATION_MODEL_FAIL,
  SanityCheckDatabricksFailed: CurrentStep.VALIDATION_MODEL_DATABRICKS_FAIL,
  SanityCheckSuccessful: CurrentStep.VALIDATION_MODEL_SUCCESS,
  RunScenarioPending: CurrentStep.RUN_MODEL,
  RunScenarioStarted: CurrentStep.RUN_MODEL,
  RunScenarioFailed: CurrentStep.RUN_MODEL,
  RunScenarioSuccessful: CurrentStep.RUN_MODEL,
};

export const getCurrentStepFromScenarioState = (scenarioState: ScenarioState): CurrentStep => {
  return stateMapping[scenarioState] ?? CurrentStep.VALIDATION_MODEL_FAIL;
};
